class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.predictiveSearchText = this.querySelector('#predictive-search-results-text');
        this.clearButton = this.querySelector('.search-bar-cross');
        this.ghostCards = this.querySelector('#ghost-cards');
        this.ghostText = this.querySelector('#predictive-search-text-ghost');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.clearButton.addEventListener('click', () => {
            this.clearInput();
        });
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            this.clearButton.style.display = 'none';
            this.hideGhostCards();
            return;
        }

        this.clearButton.style.display = 'block';
        this.showGhostCards();
        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').innerHTML;
                const predictiveSearchTextElement = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-text').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.predictiveSearchText.innerHTML = predictiveSearchTextElement;
                
                this.hideGhostCards();
                this.open();
            })
            .catch((error) => {
                this.hideGhostCards();
                this.close();
                throw error;
            });
    }

    open() {
        this.hideGhostCards();
        this.predictiveSearchResults.style.display = 'block';
        this.predictiveSearchText.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.predictiveSearchText.style.display = 'none';
    }

    showGhostCards() {
        this.close();
        this.ghostCards.classList.remove('hidden');
        this.ghostText.classList.remove('hidden');
    }

    hideGhostCards() {
        this.ghostCards.classList.add('hidden');
        this.ghostText.classList.add('hidden');
    }

    clearInput() {
        this.input.value = '';
        this.input.focus();
        this.hideGhostCards();
        this.close();
        this.clearButton.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => {
                if (!this.input.value.trim().length) {
                    this.hideGhostCards();
                    this.close();
                    this.clearButton.style.display = 'none';
                }
                fn.apply(this, args);
            }, wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
